import React, { Component } from "react";
import { connect } from "react-redux";
import {
  withStyles,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import List from "../../../API/DeliveryOfGoods";
import { OnLoadSelect } from "../../../Components/StatesForComponets";
const styles = (theme) => ({
  formControl: {
    margin: "10px",
  },
  Skeleton: {
    width: "100%",
    height: "20px",
    borderRadius: "10px 10px 10px 10px",
  },
});

const mapStateToProps = (state) => {
  return {
    Uuid: state.login.user.userUuid,
    userType: state.login.user.userType,
    Companies: state.login.user.CompaniesList,
  };
};

class Bulletin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CompaniesList: [],
      SelectedCompanie: [],
      All: "",
    };
  }

  fetchCompanyList = async () => {
    try {
      const CompanyList = await List.Types();
      console.log(CompanyList);
      if (CompanyList.status === "success") {
        this.setState({
          CompaniesList: CompanyList.data.goodDeliveryTypes,
          All: CompanyList.data.goodDeliveryTypes.map((j) => j.id),
        });
      } else {
        console.log("CompanyList NO stat error servidor ");
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleChangeState = async (event) => {
    this.props.Select([event.target.value]);
    this.setState({ SelectedCompanie: event.target.value });
  };

  componentDidMount = async () => {
    //console.log("Lista");
    await this.fetchCompanyList();
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        {this.state.CompaniesList.length > 0
          ? [
              <FormControl
                className={classes.formControl}
                style={{ width: this.props.Width ? this.props.Width : "30%" }}
              >
                <InputLabel id="demo-simple-select-label">
                  Listado de Eventos
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state.SelectedCompanie}
                  name="stateUuid"
                  onChange={this.handleChangeState}
                  //inputProps={{ readOnly: true }}
                >
                  {this.state.CompaniesList.map((companie, index) => {
                    return (
                      <MenuItem value={companie.id} key={companie.uuid}>
                        {companie.name}
                      </MenuItem>
                    );
                  })}
                  <MenuItem value={this.state.All} key={"init"}>
                    Todos los Eventos
                  </MenuItem>
                </Select>
              </FormControl>,
            ]
          : [
              <FormControl>
                <OnLoadSelect />
              </FormControl>,
            ]}
      </>
    );
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Bulletin));
